<template>
  <span v-if="loaded">
    <ValidationProvider
      :rules="fieldType['validation']['frontend']"
      v-slot="{ passed, failed }"
      v-for="(fieldRoute, fieldRouteIndex) in fieldType.data.options"
      :key="fieldRouteIndex"
    >
      <md-field
        :class="[
          { 'md-error': failed },
          { 'md-valid': passed },
          { 'md-form-group': true }
        ]"
      >
        <md-icon>directions_bus</md-icon>
        <label>Afstand tot {{ fieldRoute.name }}</label>
        <md-input
          v-model="valueData[fieldRoute.id]"
          @change="changeDistance()"
          type="number"
        >
        </md-input>

        <slide-y-down-transition>
          <md-icon class="error" v-show="failed">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="passed">done</md-icon>
        </slide-y-down-transition>
      </md-field>
    </ValidationProvider>
    <md-button
      native-type="button"
      class="md-success"
      @click.native.prevent="recalculate"
      :disabled="calculating"
      >Afstanden herberekenen</md-button
    >
    <map-routing-a-to-b
      v-if="
        routing.from.lat && routing.from.lng && routing.to.lat && routing.to.lng
      "
      style="height: 250px; width: 100%;"
      v-model="routing"
      markerA="marker-bus.png"
      markerB="marker-driver.png"
    ></map-routing-a-to-b>
  </span>
</template>
<script>
import MapRoutingAToB from "../../../components/OpenStreetMap/MapRoutingAToB.vue";

export default {
  components: {
    MapRoutingAToB
  },
  data() {
    return {
      loaded: false,
      calculating: false,
      calculateIndex: 0,
      email: "",
      fieldData: {},
      valueData: {},
      routing: {
        from: {
          lat: "",
          lng: ""
        },
        to: {
          lat: "",
          lng: ""
        },
        distance: 0
      }
    };
  },
  props: ["value", "field", "fieldType", "driverLat", "driverLng"],
  watch: {
    routing(value) {
      if (this.calculating) {
        this.setDistance(value["distance"]);

        this.$emit("input", this.valueData);

        this.calculateIndex++;
        this.recalculateRoute();
      }
    },
    driverLat(value) {
      this.routing.to.lat = value;
    },
    driverLng(value) {
      this.routing.to.lng = value;
    }
  },
  methods: {
    setLoaded() {
      this.loaded = true;
    },
    setDistance(distance) {
      this.valueData[
        this.fieldType.data.options[this.calculateIndex].id
      ] = Math.round(Number(distance));
    },
    recalculate() {
      this.calculating = true;
      this.recalculateRoute();
    },
    recalculateRoute() {
      if (this.fieldType.data.options[this.calculateIndex] === undefined) {
        this.calculateIndex = 0;
        this.calculating = false;

        this.routing.from.lat = "";
        this.routing.from.lng = "";

        this.notifyVue("Afstanden opnieuw berekend", "check", "success", 5000);

        return;
      }

      let routing = this.routing;

      routing.from.lat = Number(
        this.fieldType.data.options[this.calculateIndex]["lat"]
      );
      routing.from.lng = Number(
        this.fieldType.data.options[this.calculateIndex]["lng"]
      );

      routing.distance = 0;

      this.routing = routing;
    },
    changeDistance() {
      for (let i in this.valueData) {
        this.valueData[i] = Number(this.valueData[i]);
      }
      this.$emit("input", this.valueData);
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  created() {
    this.fieldData = this.field;

    this.routing.to.lat = this.driverLat;
    this.routing.to.lng = this.driverLng;

    for (let i in this.fieldType.data.options) {
      if (this.valueData[this.fieldType.data.options[i].id] === undefined) {
        this.valueData[this.fieldType.data.options[i].id] = 0;
      }

      if (this.value[this.fieldType.data.options[i].id] !== undefined) {
        this.valueData[this.fieldType.data.options[i].id] = this.value[
          this.fieldType.data.options[i].id
        ];
      }
    }

    setTimeout(this.setLoaded, 100);
  }
};
</script>
<style></style>
